module.exports = __webpack_public_path__ + "7f058d4f8b6e092c3b7f376a10c7b76a.MP3";